import { AKComponent } from '@theme/component';

/**
 * Search button component
 * Handles the search trigger button in the header
 *
 * @extends {AKComponent}
 */
class SearchButtonComponent extends AKComponent {
  connectedCallback() {
    super.connectedCallback();
  }
}

if (!customElements.get('search-button')) {
  customElements.define('search-button', SearchButtonComponent);
}
